import React from 'react';
import { observer } from 'mobx-react';
import { BooleanCellTrueOnlyTemplate } from 'themes/components';

@observer
class BooleanCellTrueOnly extends React.Component {
    render() {
        return (
            <BooleanCellTrueOnlyTemplate {...this.props}/>
        );
    }
}

export default BooleanCellTrueOnly;